import { useState, useEffect, useContext } from "react";
import css from "./home.module.scss";
import { AuthContext } from '../../context/auth'
import { Layout } from "../../componentsV1/layout";
import { Pill } from "../../componentsV1/Pill";
import { Card } from "../../componentsV1/Card";
import { toAbsoluteUrl } from "../../utils/assetHelper";
import Logo from "../../assets/v1/logo.png";
import { Antibody, Stack, Graph, Target } from "../../assets/v1/icons";
import 'swiper/swiper-bundle.css';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import ProductCard from "../../components/card";
import { getFeaturedApi } from '../../api'
import ItemPreviewDrawer from "../../components/Drawers/ItemPreviewDrawer"

export const HomePage = () => {
  const { openItemPreviewModal } = useContext(AuthContext)
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const whyIdentifyn = [
    {
      heading: "Biochemical Validation",
      description: "Every target is confirmed at the protein level before imaging begins.",
    },
    {
      heading: "Multi-Resolution Imaging",
      description: "Each modality contributes a specific layer of biological understanding."
    },
    {
      heading: "Resolution-Aware Interpretation",
      description: "We distinguish between localization and true molecular structure."
    }
  ]

  const applications = [
    "Antibody Validation",
    "Spatial Biology",
    "DNA Damage Response",
    "Multiplex Imaging",
    "Pharma Support",
  ];

  const steps = ["WB", "Widefield", "WF-SIM", "Confocal", "Airyscan", "SIM", "SIM²", "STORM"];

  const services = [
    {
      heading: "Rapid Validation",
      description: "Western blot validation, widefield/confocal imaging, and initial localization assessment for quick confidence in target performance.",
      otherText: "Typical timeline: 3–7 days",
      price: "$3K – $8K"
    },
    {
      heading: "Stepdown Analysis",
      description: "Full workflow from WB through SIM, with ROI analysis, structured interpretation, and resolution-aware biological conclusions.",
      otherText: "Typical timeline: 1–3 weeks",
      price: "$10K – $25K"
    },
    {
      heading: "Nanoscale Programs",
      description: "Full stepdown plus STORM, multiplex integration, and high-confidence nanoscale analysis for mechanistic or publication-grade studies.",
      otherText: "Typical timeline: 2–4+ weeks",
      price: "$25K+"
    }

  ]

  const logos = [
    {
      icon: Antibody,
      text: "Premium Antibodies"
    },
    {
      icon: Stack,
      text: "Rigorous Validation"
    },
    {
      icon: Target,
      text: "Resolution-Aware Insights"
    },
    {
      icon: Graph,
      text: "Reliable Results"
    }
  ]

    const selectRandomNumber = (length) => {
    return Math.floor(Math.random() * length)
  }

    const getBestProducts = () => {
    getFeaturedApi(true).then((res) => {
      const temp = res?.data?.products.map((item) => {
        if (item.metadata?.images.filter((_i) => _i.url !== '').length > 0) {
          const images = item?.metadata?.images.filter(({ url }) => url !== '');
          const featuredImages = images.filter(({ featuredImage }) => featuredImage);
          const imageUrl = featuredImages.length ? featuredImages[0]?.url : images[selectRandomNumber(images.length)]?.url;
          return {
            ...item,
            image: imageUrl,
          }
        }
        return item
      })
      setProducts(temp || [])
    })
  }

    useEffect(() => {
      getBestProducts()
    }, [])
  

  return (
    <Layout>
      <div className={css.heroContainer}>
        <div className={css.heroContent}>
          <img src={Logo} alt="logo" className={css.heroLogo} />
          <div className={css.heroText}>
            <h1>ANTIBODIES YOU CAN TRUST. <br/>
              DATA YOU CAN <span>DEFEND.</span></h1>
            <div className={css.line} />
            <p>We develop and validate high-performance antibodies and test them with our resolution-aware stepdown framework—so you can <span>see more, know more, and publish with confidence.</span></p>
            </div>
            <div className={css.logoContainer}>
              {logos.map((item) => {
              return (
              <div className={css.logo}>
                <img src={item.icon} alt={item.text} />
                <p>{item.text}</p>
              </div>
              )})
              }
          </div>
        </div>
      </div>
      <div className={css.container}>
        <section className={`${css.section} ${css.featuredSection}`}>
          <h2 className={css.heading}>Featured Antibodies</h2>
          <div className={css.featuredContainers}>
            <div className={css.featured}>
            <div className="slider-container">
              <div className={css.articlesContainer}>
                <Swiper
                  slidesPerView={4}
                  spaceBetween={30}
                  navigation={{
                    nextEl: '.right',
                    prevEl: '.left',
                  }}
                  breakpoints={{
                    320: {
                      slidesPerView: 1
                    },
                    640: {
                      slidesPerView: 1
                    },
                    768: {
                      slidesPerView: 2
                    },
                    1024: {
                      slidesPerView: 3
                    },
                    1200: {
                      slidesPerView: 4
                    }
                  }}
                  modules={[Navigation]}
                  className="swiper-container mySwiper"
                >
                  {products.map((item, index) => {
                    return <SwiperSlide>
                      <ProductCard index={index} item={item} key={item.id} setSelectedProduct={setSelectedProduct} />
                    </SwiperSlide>
                  })}
                </Swiper>
                <button
                  className={`icon left ${css.leftArrow}`}
                >
                  <i className="fas fa-chevron-left" aria-hidden="true"></i>
                </button>
                <button
                  className={`icon right ${css.rightArrow}`}
                >
                  <i className="fas fa-chevron-right" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            </div>
            {/* <div className={css.featured}>
              <div className={css.featuredHeading}>Featured Primary Antibodies</div>
              <div className={css.featuredCards}>
                {Array.from({ length: 6 }).map((_, i) => (
                  <div key={i} className={css.featuredCard}>
                    Add Product
                  </div>
                ))}
              </div>
            </div>
            <div className={css.featured}>
              <div className={css.featuredHeading}>Direct Conjugate Primary Antibodies</div>
              <div className={css.featuredCards}>
                {Array.from({ length: 6 }).map((_, i) => (
                  <div key={i} className={css.featuredCard}>
                    Add Product
                  </div>
                ))}
              </div>
            </div>
            <div className={css.featured}>
              <div className={css.featuredHeading}>Secondary Identifyn® SRM Alexa Fluor™ Antibodies</div>
              <div className={css.featuredCards}>
                {Array.from({ length: 6 }).map((_, i) => (
                  <div key={i} className={css.featuredCard}>
                    Add Product
                  </div>
                ))}
              </div>
            </div> */}
          </div>
        </section>
        <section className={css.section}>
          <h2 className={css.heading}>Why Identifyn</h2>
          <div className={css.cardContainer}>
            {whyIdentifyn.map((card, index) => (
              <Card key={index} heading={card.heading} description={card.description} normalHeading={true} />
            ))}
          </div>
        </section>
        <div className={css.section}>
          <section className={css.sectionBg}>
            <h2 className={css.heading}>The Stepdown Framework</h2>
            <div className={css.pillContainer}>
              {steps.map((app) => (
                <Pill key={app} text={app} />
              ))}
            </div>
            <p>Each modality answers a different question. Only together do they define biological truth.</p>
            <button className={css.btnLink}>View Full Stepdown</button>
          </section>
        </div>
        <section className={css.section}>
          <h2 className={css.heading}>Applications</h2>
          <div className={css.pillContainer}>
            {applications.map((app) => (
              <Pill key={app} text={app} haveBg={true} />
            ))}
          </div>
        </section>
        <section className={css.section}>
          <div className={css.sectionBg}>
            <div className={css.subHeading}>SERVICES</div>
            <h2 className={css.heading}>We perform the full stepdown for research and industry.</h2>
            <p>From biochemical confirmation to nanoscale imaging, Identifyn applies the same resolution-aware workflow used to validate our own products—fast, results-oriented, and cost-effective.</p>
            <div className={css.cardContainer}>
              {services.map((service, index) => (
                <Card key={index} heading={service.heading} description={service.description} otherText={service.otherText} price={service.price} />
              ))
              }
            </div>
            <div className={css.btnsContainer}>
              <button className={css.btnLink}>Start a Project</button>
              <button className={css.btnTransparent}>Request Proposal</button>
            </div>
          </div>
        </section>
        <section className={css.section}>
          <h2 className={css.heading}>We don’t just generate images. We define what they mean.</h2>
          <ul className={css.list}>
            <li>Resolution-aware interpretation</li>
            <li>Cross-modality validation</li>
            <li>Defensible biological conclusions</li>
          </ul>
        </section>
      </div>
      {openItemPreviewModal && <ItemPreviewDrawer selectedProduct={selectedProduct} setSelectedProduct={setSelectedProduct} />}
    </Layout>
  );
}